import { useShapesCreate } from '@ais-ui/api';
import { SaveShapeGroupDialog } from './SaveShapeGroupDialog';

interface BaseCreateOrEditShapeGroupProps {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

export function CreateShapeGroup(props: BaseCreateOrEditShapeGroupProps) {
  const { mutate } = useShapesCreate();

  return (
    <SaveShapeGroupDialog
      showDialog={props.showDialog}
      setShowDialog={props.setShowDialog}
      mutate={mutate}
      action="create"
    />
  );
}
